import { GET_LOADING_TYPE, GET_REGENERATE_PROBLEMATIC_REPORTS_TYPE } from './loading.actionTypes';

export default function loading(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case GET_LOADING_TYPE:
            return {
                ...newState,
                loading: action.loading
            }
        case GET_REGENERATE_PROBLEMATIC_REPORTS_TYPE:
            return {
                ...newState,
                regenerateProblematicLoading: action.regenerateProblematicLoading
            }
        default:
            return {
                ...newState,
                loading: false,
                regenerateProblematicLoading: false
            }
    }
}
